<template>
  <div class="collapse_item__wrappers">
    <div class="collapse_item__header mb-1">
      <div class="collapse_item__header_text" @click="toggle">
        <div class="remark-collapse-header">
          <div class="remark-mem">
            <el-avatar :src="item.remarkByMemImgUrl" shape="square" :size="48">
              U
            </el-avatar>
          </div>
          <div class="d-flex remark-simple-info" style="flex: 1">
            <div class="d-flex" style="flex-direction: column; flex: 1">
              <div
                style="display: flex; align-items: center"
                class="remark-user-info"
              >
                <span class="mr-25">{{ item.remarkByName }}</span>
                <span class="mr-15 remark-time">{{
                  item.remarkTimeLocale
                }}</span>
                <div class="img-icon" v-show="item.hasFile == 'Y'">
                  <el-image
                    :src="fileTagIcon"
                    style="width: 20px; height: 20px"
                  >
                  </el-image>
                </div>
              </div>
              <div v-if="closed()" class="remark-simple-content">
                {{ item.remarkText }}
              </div>
              <div v-else class="send-user">
                {{ `Send to: ${item.linkUserName}` }}
              </div>
            </div>
            <div class="d-flex remark-time">{{ item.remarkTime }}</div>
          </div>
          <div class="d-flex" style="align-items: center;margin-right: 15px;">
            <div class="icon-button" @click.stop="$emit('edit', item)">
              <el-image :src="editIcon" style="width: 19px; height: 19px">
              </el-image>
            </div>
            <div class="icon-button" @click.stop="$emit('delete', item)">
              <el-image :src="deleteIcon" style="width: 19px; height: 19px">
              </el-image>
            </div>
            <div class="icon-button" @click.stop="$emit('reply', item)">
              <el-image :src="replyIcon" style="width: 19px; height: 19px">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="collapse_item__body">
      <el-collapse-transition>
        <div v-show="!closed()">
          <slot />
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
const fileTagIcon = require('./fileTag.png')
const deleteIcon = require('./Delete@3x.png')
const editIcon = require('./Edit@3x.png')
const replyIcon = require('./Reply@3x.png')
export default {
  props: {
    title: { type: String, default: '' },
    item: { type: Object, default: {} },
  },
  inject: ['open', 'close', 'toggle', 'closed'],
  data() {
    return {
      fileTagIcon,
      deleteIcon,
      editIcon,
      replyIcon,
    }
  },
}
</script>

<style lang="scss" scoped>
.collapse_item__wrappers {
  .collapse_item__header {
    display: flex;
    align-items: center;
    .collapse_item__header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-right: 6px;
    }
    .collapse_item__header_text {
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.remark-collapse-header {
  padding-bottom: 10px;
  display: flex;
  .remark-mem {
    margin-right: 10px;
  }
  .remark-simple-info {
    .img-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
    .remark-user-info {
      font-size: 14px;
      color: #3f4254;
    }
    .remark-simple-content {
      max-width: 50%;
      color: #b5b5c3 !important;
      font-weight: 500 !important;
      font-size: 12px;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .send-user {
      font-size: 14px;
      font-weight: 500 !important;
      color: #b5b5c3;
      margin-top: 5px;
    }
    .remark-time {
      align-items: center;
      color: #b5b5c3;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.mr-25 {
  margin-right: 25px;
}
.mr-15 {
  margin-right: 15px;
}
.icon-button {
  cursor: pointer;
  margin-left: 15px;
}
</style>
